/** external */
import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
/** internal */
import { IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import { getStyleStrippedText } from "Utils";

/** relative */
import classes from "./QuestionDetailsSideBar.scss";
import { getQuestionDetailsData } from "./QuestionDetailsSideBarUtils";

const QuestionDetailsSideBar = props => {
  const {
    questionId,
    isSubQuestion,
    subQuestionParentId,
    resourceId,
    questionIndex,
    setViewQuestion,
    t,
    localeLabel,
    viewQuestion,
    userType,
    worksheetMode,
    isFromInternalTool,
    isFullScreenHeight = false,
    isQueriesV2Enabled = false,
  } = props;

  const {
    questionTitle,
    questionScore,
    parentQuestion,
    parentScore,
  } = getQuestionDetailsData({
    questionId,
    isSubQuestion,
    subQuestionParentId,
    resourceId,
    userType,
    worksheetMode,
    isFromInternalTool,
    isQueriesV2Enabled,
    t,
  });

  const showSideBar = classNames({
    [classes.questionSidebar]: true,
    [classes.questionSidebarEnable]: viewQuestion,
    [classes.fullScreenHeight]: isFullScreenHeight,
  });
  const questionTitleStyle = classNames({
    [classes.questionTitleStyle]: true,
    "heading-6 w-full": true,
  });

  const isParentQuestion = !_.isEmpty(parentQuestion);
  const questionNumber = isParentQuestion
    ? _.head(_.split(questionIndex, "."))
    : questionIndex;

  return (
    <div className={showSideBar}>
      <div className={classes.nav}>
        <div className="text-label-1">
          {t("classPlanner:preview_with_label", {
            label: t("common:question"),
          })}
        </div>
        <IconButton
          dsVersion="2.0"
          variant={"neutral"}
          type="plain"
          _legacy_variant={"plain"}
          icon={<CloseOutlined />}
          onClick={() => {
            setViewQuestion(false);
          }}
          testId="worksheet-questionDetailsSideBar-hideQuestion"
        />
      </div>

      <div className={classes.questionContent}>
        <div className={classes.questionName}>
          <div className="text-subtitle-3">
            {isFromInternalTool
              ? t(
                  isParentQuestion
                    ? "worksheet:multipart_question"
                    : localeLabel
                )
              : `${t("worksheet:question_abbreviation_with_number", {
                  number: questionNumber,
                })} - ${t(
                  isParentQuestion
                    ? "worksheet:multipart_question"
                    : localeLabel
                )}`}
          </div>
          <div className="text-subtitle-3">
            {t("common:mark_with_number_other", {
              count: isParentQuestion ? parentScore : questionScore,
            })}
          </div>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: getStyleStrippedText({
              text: isParentQuestion ? parentQuestion : questionTitle,
              type: "DOCUMENT_EDITOR",
            }),
          }}
          className={questionTitleStyle}
        />
      </div>
      {isParentQuestion ? (
        <div className={classes.subQuestion}>
          <div className={classes.questionName}>
            <div className="text-subtitle-3">
              {`${t("worksheet:question_abbreviation_with_number", {
                number: questionIndex,
              })} - ${t(localeLabel)}`}
            </div>
            <div className="text-subtitle-3">
              {t("common:mark_with_number_other", {
                count: questionScore,
              })}
            </div>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: getStyleStrippedText({
                text: questionTitle,
                type: "DOCUMENT_EDITOR",
              }),
            }}
            className={questionTitleStyle}
          />
        </div>
      ) : null}
    </div>
  );
};

QuestionDetailsSideBar.propTypes = {
  showQuestionDetailsSidebar: PropTypes.bool,
  questionId: PropTypes.string,
  isSubQuestion: PropTypes.bool,
  subQuestionParentId: PropTypes.string,
  resourceId: PropTypes.string,
  questionIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setViewQuestion: PropTypes.func,
  t: PropTypes.func,
  localeLabel: PropTypes.string,
  viewQuestion: PropTypes.bool,
  userType: PropTypes.string,
  worksheetMode: PropTypes.string,
  isFromInternalTool: PropTypes.bool,
  isFullScreenHeight: PropTypes.bool,
};

export default QuestionDetailsSideBar;
